import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, retry } from 'rxjs';
import { environment } from '../../environments/environment';
import { APICallingLimit } from './constant.service';
import { handleHttpError } from './handle-http-error.service';
import { GetAzureBlobUrlReq, RaiseSegmentRequestInCRMReq, UploadSegmentManuallyReq } from '../models/request.model';

@Injectable({
  providedIn: 'root'
})
export class ProofSelectionService {

  constructor(private http: HttpClient) { }

  RaiseSegmentRequestInCRM(
    raiseSegmentRequestInCRMReq: RaiseSegmentRequestInCRMReq
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': environment.gateWayModificationKey,
    });
    return this.http
      .post<any>(
        environment.baseModificationAPI + 'RaiseSegmentRequestInCRM',
        raiseSegmentRequestInCRMReq,
        { headers }
      )
      .pipe(retry(APICallingLimit.one_1), catchError(handleHttpError));
  }

  UploadSegmentManually(
    uploadSegmentManuallyReq: UploadSegmentManuallyReq
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': environment.gateWayModificationKey,
    });
    return this.http
      .post<any>(
        environment.baseModificationAPI + 'UploadSegmentManually',
        uploadSegmentManuallyReq,
        { headers }
      )
      .pipe(retry(APICallingLimit.one_1), catchError(handleHttpError));
  }
  
  GetAzureBlobUrl(
    getAzureBlobUrlReq: GetAzureBlobUrlReq
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': environment.gateWayModificationKey,
    });
    return this.http
      .post<any>(
        environment.baseModificationAPI + 'GetAzureBlobUrl',
        getAzureBlobUrlReq,
        { headers }
      )
      .pipe(retry(APICallingLimit.one_1), catchError(handleHttpError));
  }

}
